var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[_c('header',{staticClass:"header container"},[_c('header-top'),_c('header-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }